import actionTypes from "../actionTypes/editor";

export const updateEditorValue = (payload) => ({
  payload,
  type: actionTypes.UPDATE_EDITOR_VALUE,
});
